import React, { useState, useEffect, useCallback } from 'react';
import './ReviewBlock.css';

function StarDisplay({ stars, size }) {
    return (
        <span className={`review-stars${size === 'sm' ? ' review-stars-sm' : ''}`}>
            {[1, 2, 3, 4, 5].map(i => (
                <span key={i} className={i <= stars ? 'star filled' : 'star empty'}>★</span>
            ))}
        </span>
    );
}

function formatDate(dateStr) {
    const d = new Date(dateStr);
    return d.toLocaleDateString('de-DE', { day: 'numeric', month: 'long', year: 'numeric' });
}

export function ReviewBlock() {
    const [summary, setSummary] = useState(null);
    const [recent, setRecent] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        fetch('api/Review/Summary').then(r => r.json()).then(setSummary).catch(() => {});
        fetch('api/Review/Recent').then(r => r.json()).then(setRecent).catch(() => {});
    }, []);

    const goNext = useCallback(() => {
        setCurrentIndex(i => (i + 1) % recent.length);
    }, [recent.length]);

    const goPrev = () => {
        setCurrentIndex(i => (i - 1 + recent.length) % recent.length);
    };

    useEffect(() => {
        if (recent.length <= 1) return;
        const timer = setInterval(goNext, 5000);
        return () => clearInterval(timer);
    }, [recent.length, goNext]);

    if (!summary || summary.totalCount === 0) return null;

    return (
        <div className="review-block">
            <div className="review-block-header">
                <StarDisplay stars={Math.round(summary.averageStars)} />
                <span className="review-block-avg">{summary.averageStars.toFixed(1)}&thinsp;/&thinsp;5</span>
                <span className="review-block-count">({summary.totalCount} Bewertungen)</span>
                <a href="/reviews" className="review-block-link">Alle anzeigen →</a>
            </div>

            {recent.length > 0 && (
                <div className="review-carousel">
                    {recent.length > 1 && (
                        <button className="review-carousel-btn" onClick={goPrev} aria-label="Vorherige Bewertung">&#8249;</button>
                    )}
                    <div className="review-card">
                        <StarDisplay stars={recent[currentIndex].stars} size="sm" />
                        <p className="review-card-comment">&ldquo;{recent[currentIndex].comment}&rdquo;</p>
                        <p className="review-card-meta">
                            {recent[currentIndex].displayName} &middot; {formatDate(recent[currentIndex].date)}
                        </p>
                    </div>
                    {recent.length > 1 && (
                        <button className="review-carousel-btn" onClick={goNext} aria-label="Nächste Bewertung">&#8250;</button>
                    )}
                    {recent.length > 1 && (
                        <div className="review-carousel-dots">
                            {recent.map((_, i) => (
                                <button
                                    key={i}
                                    className={`review-carousel-dot${i === currentIndex ? ' active' : ''}`}
                                    onClick={() => setCurrentIndex(i)}
                                    aria-label={`Bewertung ${i + 1}`}
                                />
                            ))}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
